import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  buttonsContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: indent,
    paddingVertical: indent / 2,
  },
  buttonsContainerColumn: {
    flexDirection: 'column',
  },
  title: {
    paddingHorizontal: indent / 2,
    textAlign: 'center',
  },
  description: {
    marginTop: indent,
    paddingHorizontal: indent / 2,
  },
  primaryButtonColumn: {
    marginBottom: indent / 2,
  },
  container: {
    paddingBottom: indent / 2,
    paddingTop: indent * 1.5,
    paddingHorizontal: indent,
  },
  split: {
    width: indent * 0.75,
  },
});
